const marketingBannerStyle = Object.freeze({
  fontStack: 'alt',
  textTransform: 'uppercase',
  topStrip: Object.freeze({
    typeScale: -1,
    buttonTypeScale: -2,
  }),
});

export default marketingBannerStyle;
